var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVlEmblemOnlyLight(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Light",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 329 360.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .st0 {\r\n        fill: #e0e0e0;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "V_Star"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M194.6,237.9l-23.7,54.4h-1.8L70.9,87.4l-20.9-17.6h96.1l-19.1,18.2,67.6,149.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M239.7,49.4l4.7,13.7c3.3,9.5,10.6,17.2,20,20.9l12.1,4.8-12.1,4.8c-9.4,3.7-16.7,11.3-20,20.9l-4.7,13.7-4.7-13.7c-3.3-9.5-10.6-17.2-20-20.9l-12.1-4.8,12.1-4.8c9.4-3.7,16.7-11.3,20-20.9,0,0,4.7-13.7,4.7-13.7Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVlEmblemOnlyLight);
export default __webpack_public_path__ + "static/media/VL_EmblemOnly_Light.32b6ef2c37d2fa2fe49f47a140bee5b2.svg";
export { ForwardRef as ReactComponent };